/* eslint-disable no-undef */
// eslint-disable-next-line no-unused-vars
$(document).ready(function () {
  $('.dropdown-toggle').click(function () {
    $(this).parent().find('.dropdown-mobile').toggleClass('show')
  })
})



// WEBPACK FOOTER //
// ./src/assets/js/script.js